export default {
    type: 'set',
    format: {},
    default: {
        logic: 'match',
        value: []
    },
    setting: {
        logic: ['match', 'oneof']
    },
    link: {},
    usage: {
        owners: ['user'],
        results: ['collection','play','rating','game']
    },
    lang: {
        name: 'Play Location',
        category: ['User', 'Plays'],
        description: 'Where play was labelled as being located.',
        summarise: {
            prefix: 'Play location'
        },
        unit: 'location'
    }
}